import { IQueryContext } from 'framework/context/IQueryContext';
import { IOrdersQueryMetadata, IOrdersQueryParams, IOrderV2, IQueryResultWithMetadata } from 'gen/ApiClient';
import React from 'react';

export const OrdersQueryContext = React.createContext<IQueryContext<IQueryResultWithMetadata<IOrderV2, IOrdersQueryMetadata>, IOrdersQueryParams>>(
	undefined as any
);
